import axios from '@/axios-mock'

export function getCartNum () {
  return axios({
    url: `/app/cart/packs/size`
  })
}


// WEBPACK FOOTER //
// ./static/components/cart/apis.js